import React, {Component} from 'react';
import { connect } from 'react-redux';
import ReactDataSheet from 'react-datasheet';
import 'react-datasheet/lib/react-datasheet.css';
import { getSavedSimulations, updateRawData } from '../../../actions/dataAction';
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTrash from '@fortawesome/fontawesome-free-solid/faTrashAlt';
import { BoxButton } from '../../StyledComponents';

const SentimentReports = styled.div`
  position: relative;
  height: 500px;
  overflow: scroll;
  padding: 5px;
  font-size: 12px;

  & .data-grid {
    min-width: 100%;
  }

  & .value-viewer {
    text-align: left;
    padding: 2px;
  }
`

const TrashBin = styled(FontAwesomeIcon)`
    margin-left:10px;
`;

const defaultRow = [{value:  "", type: "param"}, {value:  "", type: "date"}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}];

const defaultGrid = [
  [{value:  "", type: "param"}, {value:  "", type: "date"}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}, {type:"value", value: ""}]
];

class DataEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  resetData() {
    this.props.updateRawData(defaultGrid) && this.forceUpdate();
  }

  render() {
    const { user } = this.props;

    if (!Array.isArray(user.client.rawData)) {
      this.props.updateRawData(defaultGrid);
    }

    let gridData = user.client && user.client.rawData && Array.isArray(user.client.rawData) && user.client.rawData || defaultGrid;

    const columns = [{name:"Parameter"},{name:"Date"}]
    return (
      <div className="row">
        <div className="col-md-12">
          <SentimentReports>
            <BoxButton dark onClick={() => gridData.push(defaultRow) && this.forceUpdate()}>Add row</BoxButton>
            <BoxButton dark onClick={() => this.resetData()}>Reset data</BoxButton>

            <ReactDataSheet
              data={gridData}
              valueRenderer={(cell) => cell.value}
              sheetRenderer={props => (
                  <table className={props.className + ' my-awesome-extra-class'}>
                      <thead>
                          <tr>
                            {columns.map(col => (<th>{col.name}</th>))}
                            <th className='action-cell' />
                          </tr>
                      </thead>
                      <tbody>
                          {props.children}
                      </tbody>
                  </table>
                )}
              rowRenderer={props => (
                  <tr>
                      {props.children}
                      <td className='cell' width="30" style={{maxWidth:'30px', textAlign:'center'}}>
                        <TrashBin icon={faTrash} onClick={(e) => gridData.splice(props.row, 1) && this.forceUpdate()}/>
                      </td>
                  </tr>
                )}
              onCellsChanged={(changes, arrayOfAdditions) => {
                let grid = gridData.map(row => [...row])
                changes.forEach(({cell, row, col, value}) => {
                  grid[row][col] = {...grid[row][col], value}
                })

                this.props.updateRawData(grid);
              }}
            />
          </SentimentReports>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps, { getSavedSimulations, updateRawData })(DataEditor);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/DataEditor.js